import React, { useEffect, useState } from "react";
import LoadingPage from "../../../Components/layouts/loading";
import StepRoutes from "../../../Routes/steps_routes";
import { FieldArray, Form, Formik } from "formik";
import CustomInput from "../../../CustomComponent/custom_input";
import CustomSelect from "../../../CustomComponent/custom_select";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
import { roundOffCost } from "../../../Components/Functions/amt.fun";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import { useNavigate, useParams } from "react-router-dom";
// import { lineItemInfo } from "../../../SchemaInfo/info";
import { GrnlineItemInfo } from "../../../SchemaInfo/info";
import { useSelector } from "react-redux";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";

import { getId } from "../../../Components/Functions/word.fun";
import { GrnInfo } from "../../../SchemaInfo/info";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { GrnPurchaseOrderSchema } from "../../../Schemas/purchase/grn_schema";
import { FcFinePrint } from "react-icons/fc";

const EditGRNPurchaseOrder = () => {
  let userData = useSelector((store) => store.login.user);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [vendors, setVendors] = useState([]);
  const { id } = useParams();
  const [data, setData] = useState(GrnInfo);
  const [projects, setProjects] = useState([]);
  const [materialData, setMaterialData] = useState([]);
  const [poId, setPoId] = useState([]);

  useEffect(() => {
    performRequest("GET", "/materialPlanning/getAllMaterialList")
      .then((res) => {
        if (res.status === 200) {
          setMaterialData(res.data?.MaterialList);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  useEffect(() => {
    performRequest("GET", "/siteInspection/getAllProjects")
      .then((res) => setProjects(res.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);

  const handelSubmit = (values, actions) => {

    let CompData = values?.lineItems?.map((item, index) => {
      return {
        ...item,
        totalWithGst:
          item.recivedQty * item.itemPrice -
          (item.recivedQty * item.itemPrice * item.discount) / 100 +
          ((item.recivedQty * item.itemPrice -
            (item.recivedQty * item.itemPrice * item.discount) / 100) *
            item.gstRate) /
            100,
        totalWithoutGst:
          item.recivedQty * item.itemPrice -
          (item.recivedQty * item.itemPrice * item.discount) / 100,
      };
    });
    values = { ...values, lineItems: CompData };

    setLoading(true);
    performRequest("PATCH", `/grn/updateGrn/${id}`, values)
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "GRN Updated successfully!");
            navigate(`/view-grn-items/${id}`);
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    performRequest("GET", "/poDcPi/getAllVendorList")
      .then((res) => setVendors(res.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);

  useEffect(() => {
    performRequest("GET", "/poDcPi/getPoNum")
      .then((res) => setPoId(res.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/grn/getGrnById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData({
            ...res.data,
            lineItems: res.data?.lineItems,
            poId: getId(res.data?.poNumber) || [],
          });
        } else {
          Toast("error", "Error while getting PO!");
        }
        setLoading(false);
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return <LoadingPage />;
  }
  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcFinePrint />
                  GRN System
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">Edit GRN</h2>
            </div>
            <Formik
              initialValues={data}
              enableReinitialize={true}
              validationSchema={GrnPurchaseOrderSchema}
              onSubmit={handelSubmit}
            >
              {(props) => (
                <Form>
                  <div className="card-body">
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Purchase Order Number
                      </label>
                      <div className="w-100 col">
                        <CustomSelect name="poId" disabled>
                          <option value="">Select Purchase Order</option>

                          {poId.map((po) => {
                            return (
                              <option
                                key={getId(po?.poNumber)}
                                value={getId(po?.poNumber)}
                              >
                                {po?.poNumber}
                              </option>
                            );
                          })}
                        </CustomSelect>
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Vendor purchase order for
                      </label>
                      <div className="w-100 col">
                        <CustomSelect
                          type="text"
                          name="vendorPurchaseOrderFor"
                          disabled
                        >
                          <option value="">Select</option>
                          <option value="for client">For Client</option>
                          <option value="for stocking">For Stocking</option>
                        </CustomSelect>
                        {props.touched.vendorPurchaseOrderFor &&
                          props.errors.vendorPurchaseOrderFor && (
                            <p className="text-danger">
                              {props.errors.vendorPurchaseOrderFor}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Vendor purchase order date
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="date"
                          name="vendorPurchaseOrderDate"
                          disabled
                        />
                        {props.touched.vendorPurchaseOrderDate &&
                          props.errors.vendorPurchaseOrderDate && (
                            <p className="text-danger">
                              {props.errors.vendorPurchaseOrderDate}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Country of supply
                      </label>
                      <div className="w-100 col">
                        <CustomSelect
                          type="text"
                          name="countryOfSupply"
                          disabled
                        >
                          <option value="">Select Country</option>
                          <option value="india">India</option>
                        </CustomSelect>
                        {props.touched.countryOfSupply &&
                          props.errors.countryOfSupply && (
                            <p className="text-danger">
                              {props.errors.countryOfSupply}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Vendor
                      </label>
                      <div className="w-100 col">
                        <CustomSelect type="text" name="vendor" disabled>
                          <option value="">Select</option>
                          {vendors?.map((item) => {
                            return (
                              <option key={item.id} value={item.id}>
                                {item.businessName}
                              </option>
                            );
                          })}
                        </CustomSelect>

                        {props.touched.vendor && props.errors.vendor && (
                          <p className="text-danger">{props.errors.vendor}</p>
                        )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Payment Type
                      </label>
                      <div className="w-100 col">
                        <CustomSelect type="text" name="paymentType" disabled>
                          <option value="">Select</option>
                          <option value="onetime">One time</option>
                          <option value="partially">Partially</option>
                        </CustomSelect>

                        {props.touched.paymentType &&
                          props.errors.paymentType && (
                            <p className="text-danger">
                              {props.errors.paymentType}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Payment amount (rs)
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          name="paymentAmount"
                          disabled
                        />

                        {props.touched.paymentAmount &&
                          props.errors.paymentAmount && (
                            <p className="text-danger">
                              {props.errors.paymentAmount}
                            </p>
                          )}
                      </div>
                    </div>
                    {/* <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Proforma invoice
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="performaInvoice"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "performaInvoice",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.performaInvoice &&
                          props.errors.performaInvoice && (
                            <p className="text-danger">
                              {props.errors.performaInvoice}
                            </p>
                          )}
                      </div>
                    </div> */}
                    {/* <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Tax invoice
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="taxInvoice"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue("taxInvoice", e.target.files[0])
                          }
                        />
                        {props.touched.taxInvoice &&
                          props.errors.taxInvoice && (
                            <p className="text-danger">
                              {props.errors.taxInvoice}
                            </p>
                          )}
                      </div>
                    </div> */}
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Project
                      </label>
                      <div className="w-100 col">
                        <CustomSelect type="text" name="project" disabled>
                          <option value="">Select</option>
                          {projects &&
                            projects?.map((pro) => {
                              return (
                                <option
                                  key={pro.cpNumber}
                                  value={getId(pro.cpNumber)}
                                >
                                  {pro.clientName}
                                </option>
                              );
                            })}
                        </CustomSelect>
                        {props.touched.project && props.errors.project && (
                          <p className="text-danger">{props.errors.project}</p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Notes</label>
                      <div className="w-100 col">
                        <CustomTextArea type="text" name="notes" />

                        {props.touched.notes && props.errors.notes && (
                          <p className="text-danger">{props.errors.notes}</p>
                        )}
                      </div>
                    </div>
                    <hr />
                    <h3>Line Items :</h3>
                    <hr />
                    <FieldArray name="lineItems">
                      {({ push, remove }) => (
                        <div>
                          {props.values?.lineItems?.map((lineItem, index) => (
                            <>
                              <div key={index}>
                                <div className="row g-3 align-items-center">
                                  {props?.values?.lineItems?.[index]
                                    ?.itemFrom !== "inventory" && (
                                    <div className="col-md">
                                      <label className=" form-label">
                                        Particulars:
                                      </label>
                                      <div className="w-100 col">
                                        <CustomInput
                                          type="text"
                                          name={`lineItems[${index}].particulars`}
                                          disabled
                                        />
                                      </div>
                                    </div>
                                  )}
                                  {props?.values?.lineItems?.[index]
                                    ?.itemFrom === "inventory" && (
                                    <div className="col-md">
                                      <label className=" form-label ">
                                        Particulars
                                      </label>

                                      <div className="w-100 col">
                                        <CustomSelect
                                          type="text"
                                          name={`lineItems[${index}].particulars`}
                                          value={
                                            props?.values?.lineItems?.[index]
                                              ?.id
                                          }
                                          disabled
                                          onChange={(e) => {
                                            let item = materialData?.find(
                                              (el) => el.id == e.target.value
                                            );
                                            props.setFieldValue(
                                              `lineItems[${index}].particulars`,
                                              item?.item
                                            );
                                            props.setFieldValue(
                                              `lineItems[${index}].id`,
                                              item?.id
                                            );
                                            props.setFieldValue(
                                              `lineItems[${index}].hsn`,
                                              item?.hsn
                                            );
                                            props.setFieldValue(
                                              `lineItems[${index}].itemUnit`,
                                              item?.unit
                                            );
                                            props.setFieldValue(
                                              `lineItems[${index}].itemPrice`,
                                              item?.cost
                                            );
                                            props.setFieldValue(
                                              `lineItems[${index}].sku`,
                                              item?.sku
                                            );
                                          }}
                                        >
                                          <option value="">Select</option>
                                          {materialData?.map((el) => {
                                            return (
                                              <option
                                                key={el.id}
                                                value={el?.id}
                                              >
                                                {el?.item}
                                              </option>
                                            );
                                          })}
                                        </CustomSelect>
                                      </div>
                                    </div>
                                  )}
                                  {/* {props?.values?.lineItems?.[index]
                                    ?.itemFrom === "inventory" && (
                                    <div className="col-md">
                                      <label className=" form-label">SKU</label>
                                      <div className="w-100 col">
                                        <CustomInput
                                          type="text"
                                          name={`lineItems[${index}].sku`}
                                        />
                                      </div>
                                    </div>
                                  )} */}
                                  <div className="col-md">
                                    <label className=" form-label ">
                                      Item units
                                    </label>

                                    <div className="w-100 col">
                                      <CustomSelect
                                        type="text"
                                        name={`lineItems[${index}].itemUnit`}
                                        disabled
                                      >
                                        <option value="">Select</option>
                                        <option value="nos">Nos</option>
                                        <option value="kg">Kg</option>
                                        <option value="grams">Grams</option>
                                        <option value="ltr">Litter</option>
                                        <option value="ml">ML</option>
                                        <option value="packs">Packs</option>
                                        <option value="pair">Pair</option>
                                        <option value="sqm">SqM</option>
                                        <option value="sqft">SqFt</option>
                                        <option value="mts">Meters</option>
                                        <option value="pcs">Pices</option>
                                      </CustomSelect>
                                    </div>
                                  </div>
                                  <div className="col-md">
                                    <label className=" form-label ">
                                      Quantity
                                    </label>
                                    <div className="w-100 col">
                                      <CustomInput
                                        type={"text"}
                                        disabled
                                        name={`lineItems[${index}].itemQuantity`}
                                      />
                                    </div>
                                  </div>

                                  <div className="col-md">
                                    <label className="form-label">
                                      Received Quantity
                                    </label>

                                    <CustomInput
                                      type="text"
                                      name={`lineItems[${index}].recivedQty`}
                                      min={0}
                                      max={Number(
                                        props.values.lineItems[index]
                                          ?.itemQuantity || 0
                                      )}
                                      onChange={(e) => {
                                        const receivedQty = Number(
                                          e.target.value
                                        );

                                        const qty = Number(
                                          props.values.lineItems[index]
                                            ?.itemQuantity || 0
                                        );

                                        if (
                                          e.target.value !== "" &&
                                          receivedQty > qty
                                        ) {
                                          alert(
                                            `Received quantity cannot be greater than quantity (${qty})`
                                          );

                                          // Clear the received quantity field
                                          props.setFieldValue(
                                            `lineItems[${index}].recivedQty`,
                                            ""
                                          );

                                          return;
                                        }

                                        // Save valid value
                                        props.setFieldValue(
                                          `lineItems[${index}].recivedQty`,
                                          e.target.value
                                        );
                                      }}
                                    />
                                  </div>

                                  {/* <div className="col-md">
                                    <label className=" form-label ">
                                      Item price
                                    </label>
                                    <div className="w-100 col">
                                      <CustomInput
                                        type="text"
                                        name={`lineItems[${index}].itemPrice`}
                                        disabled
                                      />
                                    </div>
                                  </div> */}

                                  {/* <div className="col-md">
                                    <label className=" form-label ">
                                      GST (%)
                                    </label>
                                    <div className="w-100 col">
                                      <CustomSelect
                                        type="text"
                                        name={`lineItems[${index}].gstRate`}
                                        disabled
                                      >
                                        <option value="">Select</option>
                                        <option value="0">0 %</option>
                                        <option value="5">5%</option>
                                        <option value="12">12%</option>
                                        <option value="18">18%</option>
                                        <option value="28">28%</option>
                                        <option value="100">100%</option>
                                      </CustomSelect>
                                    </div>
                                  </div> */}
                                  {/* <div className="col-md">
                                    <label className=" form-label ">
                                      Delivery date
                                    </label>
                                    <div className="w-100 col">
                                      <CustomInput
                                        name={`lineItems[${index}].deliveryDate`}
                                        type="date"
                                      ></CustomInput>
                                    </div>
                                  </div> */}
                                </div>
                                <div className="row g-3 align-items-center mt-2">
                                  <div className="col-md">
                                    {/* <label className=" form-label ">
                                      Discount
                                    </label> */}
                                    <div className="w-100 col ">
                                      {/* <CustomInput
                                        type={"text"}
                                        name={`lineItems[${index}].discount`}
                                      /> */}
                                    </div>
                                  </div>
                                  <div className="col-md">
                                    {/* <label className=" form-label ">Note</label> */}
                                    <div className="w-100 col">
                                      {/* <CustomTextArea
                                        type={"text"}
                                        name={`lineItems[${index}].notes`}
                                      /> */}
                                    </div>
                                  </div>

                                  {/* <div className="col-md">
                                    <label className=" form-label ">
                                      Amount (excl GST)
                                    </label>

                                    <div className="w-100 col">
                                      {roundOffCost(
                                        lineItem.recivedQty *
                                          lineItem.itemPrice -
                                          (lineItem.recivedQty *
                                            lineItem.itemPrice *
                                            lineItem.discount) /
                                            100
                                      )}
                                    </div>
                                  </div> */}
                                  {/* add po */}
                                  {/* <div className="col-md">
                                    <label className=" form-label ">
                                      Amount (Inc GST):
                                    </label>
                                    <div className="w-100 col">
                                      {roundOffCost(
                                        lineItem.recivedQty *
                                          lineItem.itemPrice -
                                          (lineItem.recivedQty *
                                            lineItem.itemPrice *
                                            lineItem.discount) /
                                            100 +
                                          ((lineItem.recivedQty *
                                            lineItem.itemPrice -
                                            (lineItem.recivedQty *
                                              lineItem.itemPrice *
                                              lineItem.discount) /
                                              100) *
                                            lineItem.gstRate) /
                                            100
                                      )}
                                    </div>
                                  </div> */}
                                </div>
                                <hr />
                              </div>
                            </>
                          ))}
                        </div>
                      )}
                    </FieldArray>
                  </div>
                  <div className="card-footer">
                    <div className="btn-list justify-content-end">
                      <FormSubmitButton buttonText="Edit GRN" />

                      <SimpleButton buttonText="Cancel" type="secondary" />
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default EditGRNPurchaseOrder;
